import { Modal, ModalFuncProps } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export const useModal = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { t } = useTranslation();

  const confirm = (props: ModalFuncProps) => {
    return modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: t('general.cannotBeUndone'),
      okButtonProps: { type: 'primary', danger: true },
      ...props,
    });
  };

  return { confirm, contextHolder };
};
